import React, { useEffect, useState } from 'react'
import { encode, decode } from 'shopify-gid'
import cx from 'classnames'

import { client, useAddItemToCart } from 'src/context/siteContext'

export const SingleSelector = ({
  liveVariants,
  activeVariant,
  handleSelection,
}) => {
  let edd = (() => ({})) as (arg1?: any, arg2?: any) => void

  const domElement = React.createRef() as React.RefObject<HTMLSelectElement>

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const pushVariant = liveVariants?.find(({ id }) => {
      return id === e.target.value
    }, [])
    handleSelection(pushVariant)
  }

  useEffect(() => {
    edd = require("easydropdown").default

    edd(domElement.current, {
      behavior: {
        openOnFocus: true
      }
    })
  }, [0])

  return (
    <div className="select__single caps block ac ">
      <select
        value={activeVariant}
        className="f jcc s1 aic"
        onChange={e => handleChange(e)}
        ref={domElement}
      >
        {liveVariants?.map(variant => {
          return (
            <option
              key={variant.id}
              className={cx("s1 rel f jcc aic", {
                active: variant.id === activeVariant,
              })}
              value={variant.id}
              disabled={!variant.available}
              data-title={variant.title}
            >
              {variant.title}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export const ProductForm = ({ title, defaultPrice, productId, showQuantity, waitlist = true, addText }: {
  title: string
  defaultPrice: string
  productId: number
  waitlist?: boolean | true
  showQuantity?: boolean | true
  addText?: string
}) => {
  const addItemToCart = useAddItemToCart()

  const [quantity, setQuantity] = useState(1 as number)
  const [adding, setAdding] = useState(false as boolean)
  const [available, setAvailable] = useState(false)
  const [variants, setVariants] = useState([])
  const [activeVariantId, setActiveVariantId] = useState('' as string)
  const [compareAtPrice, setCompareAtPrice] = useState(undefined as string | undefined)
  const [check, setCheck] = useState(true)

  const form = React.createRef()

  useEffect(() => {
    if (check) {
      const shopifyId = encode("Product", productId, {
        accessToken: process.env.GATSBY_SHOPIFY_TOKEN,
      })

      client.product.fetch(shopifyId).then((product: any) => {
        const decodedVariants = [] as any
        product.variants.forEach((variant: any) => {
          decodedVariants.push({
            ...variant,
            cleanId: parseInt(decode(variant.id).id, 0)
          })
        })
        const dropVariants = [] as any
        product.variants.forEach((variant: any) => {
          dropVariants.push({
            ...variant,
            value: variant.id,
            disabled: variant.available
          })
        })
        setVariants(dropVariants)
        setActiveVariantId(decodedVariants[0].id as string)
        setAvailable(decodedVariants[0].available)

        if (decodedVariants[0].compareAtPrice) setCompareAtPrice(decodedVariants[0].compareAtPrice)

        setCheck(false)
      })
    }
  }, [])


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setAdding(true)
    if (available) {
      addItemToCart(activeVariantId, quantity).then(() => {
        setAdding(false)
      })
    }
  }

  const handleSelection = (e) => {
    setActiveVariantId(e.id)
  }

  return (
    <div className='container--m'>
      <h2 className='ac product__price x'>
        ${parseFloat(defaultPrice * quantity).toFixed(2)}
      </h2>
      {available && !check ? (
        <form onSubmit={(e) => handleSubmit(e)} ref={form}>
          {variants.length > 1 && (
            <div>
              <SingleSelector
                liveVariants={variants}
                activeVariant={activeVariantId}
                handleSelection={handleSelection}
                />
            </div>
          )}
          <div className='s24 product__form mxa f jcc aist'>
            {showQuantity && (
              <div className='product__form-qty cb bb f jcb aic'>
                <div className='f jcc p05 px1 aic product__form-qty-wrapper mxa'>
                  <button type='button' className='block rel s1 qty__control no-style mr1 pr1  cursor  aic' onClick={() => quantity === 1 ? null : setQuantity(quantity - 1)}>-</button>
                  <span type='number' name='quantity' min='1' className='cb s1 ml05 mr05 card-qty bn ac'>{quantity}</span>
                  <button type='button' className='qty__control no-style s1 block   cursor rel  jcc aic' onClick={() => setQuantity(quantity + 1)}>+</button>
                </div>
              </div>
            )}
            <button type='submit' className='ml05 x px05 s1 button--border cb caps s20 button'>
              <span>{adding ? 'Adding' : addText ? addText : 'Add to Cart'}</span>
            </button>
          </div>
        </form>
      ): (
        <div>
          {available ? (
            <span>Checking Stock</span>
          ): 
            waitlist ? (
              <div className='mt1 pt1 ac'>
                <span className='s20 caps h4'>Sold Out</span>
              </div>
            ) : (
              // Left empty for now
              <div className='ac x bold'>
                <span className='small' />
              </div>
            )
          }
        </div>
      )}
    </div>
  )
}